import { Component, input, output } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'app-submit-login-button',
  template: `
    <button
      type="button"
      [disabled]="disabled() || isLoading()"
      (click)="handleClick()"
      class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span class="absolute left-0 inset-y-0 flex items-center pl-3">
        @if (isLoading()) {
        <svg
          class="animate-spin h-5 w-5 text-orange-300"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        } @else {
        <svg
          class="h-5 w-5 text-orange-300 group-hover:text-orange-200"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a5 5 0 0110 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
        }
      </span>
      {{ isLoading() ? loadingText() : text() }}
    </button>
  `,
})
export class SubmitLoginButtonComponent {
  text = input<string>('Submit');
  loadingText = input<string>('Submitting...');
  isLoading = input<boolean>(false);
  disabled = input<boolean>(false);

  submitClick = output<void>();

  handleClick(): void {
    if (!this.disabled() && !this.isLoading()) {
      this.submitClick.emit();
    }
  }
}
